import { PrinterPosMinusOutlineIcon } from './PrinterPosMinusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id DD9AE6D3-6DF8-4CBC-A40F-CA25E4E6B310
 * name printer-pos-minus-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-minus-outline.svg
 * tags
 * - Printer 
 */
export const PrinterPointOfSaleMinusOutlineIcon = PrinterPosMinusOutlineIcon;
export default PrinterPointOfSaleMinusOutlineIcon